import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { VolumeUp, VolumeOff, Casino, Replay, Undo } from '@material-ui/icons/';
import { IGameData } from '../../../../redux/types';
import global from '../../../../global';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { amber } from '@material-ui/core/colors';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { Typography } from '@material-ui/core';

export const TipsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <rect fill="none" height="24" width="24" y="0" />
    <path d="M7,20h4c0,1.1-0.9,2-2,2S7,21.1,7,20z M5,19h8v-2H5V19z M16.5,9.5c0,3.82-2.66,5.86-3.77,6.5H5.27 C4.16,15.36,1.5,13.32,1.5,9.5C1.5,5.36,4.86,2,9,2S16.5,5.36,16.5,9.5z M14.5,9.5C14.5,6.47,12.03,4,9,4S3.5,6.47,3.5,9.5 c0,2.47,1.49,3.89,2.35,4.5h6.3C13.01,13.39,14.5,11.97,14.5,9.5z M21.37,7.37L20,8l1.37,0.63L22,10l0.63-1.37L24,8l-1.37-0.63L22,6 L21.37,7.37z M19,6l0.94-2.06L22,3l-2.06-0.94L19,0l-0.94,2.06L16,3l2.06,0.94L19,6z" />
  </SvgIcon>
);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      borderRadius: 8,
      backgroundColor: '#4e342e !important',
    },
    content: {
      flexDirection: 'column',
      gap: '8px',
      padding: '0 9%',
      margin: '0 auto',
      width: '100%',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
    },
    scores: {
      paddingTop: theme.spacing(1),
      fontWeight: 'bold',
    },
    volume: {
      color: amber[100],
    },
  })
);

type Props = {
  gameId: number;
  gameData: IGameData;
  onHint: () => void;
  onUndo: () => void;
  onFullScreen: () => void;
  toggleMenu: () => void;
  onShowPaymentSubscription: () => void;
  onVolumeChange: () => void;
  volume: boolean;
};

export default function DesktopBar(props: Props) {
  const { gameId, onHint, onUndo, onVolumeChange, volume } = props;
  const classes = useStyles();

  return (
    <AppBar position="relative" classes={{ root: classes.appBar }}>
      <div className={classes.content}>
        <Typography variant="subtitle1" className={classes.scores}>
          Расклад #{gameId}
        </Typography>
        <Button
          color="secondary"
          fullWidth
          startIcon={<Casino />}
          size="small"
          variant="contained"
          onClick={() => {
            global.ee.emit('new_game');
          }}
        >
          Новая игра
        </Button>
        <Button
          color="secondary"
          fullWidth
          startIcon={<Replay />}
          size="small"
          variant="contained"
          onClick={() => {
            global.ee.emit('restart');
          }}
        >
          Переиграть
        </Button>

        <Button color="secondary" fullWidth onClick={onHint} variant="contained" size="small" startIcon={<TipsIcon />}>
          Подсказка
        </Button>
        <Button color="secondary" fullWidth variant="contained" onClick={onUndo} size="small" startIcon={<Undo />}>
          Отменить
        </Button>
        <IconButton
          onClick={() => {
            onVolumeChange();
            global.volume = !global.volume;
            if (global.volume) {
              localStorage.removeItem('volumeOff');
            } else {
              localStorage.setItem('volumeOff', 'true');
            }
          }}
        >
          {volume ? <VolumeUp className={classes.volume} /> : <VolumeOff className={classes.volume} />}
        </IconButton>
      </div>
    </AppBar>
  );
}
